import { plainToClass } from "class-transformer";
import { DateUpdatedSection } from "../../../../shared/components/date-updated-section/date-updated-section.view";
import { Unique } from "../../../../shared/scripts/array-functions";
import { IFilter } from "../../../../shared/scripts/filtering/filtering.entities";
import { GetSelectedDropdownValues, InitializeFilterDropdown } from "../../../../shared/scripts/filtering/filtering.utilities";
import { SiteInfo } from "../../sites/shared/sites.entities";
import { PrescreeningChart } from "./prescreening.chart";
import { PrescreeningEntry, PrescreeningGraphDataPoint } from "./prescreening.entities";
import { PrescreeningTable } from "./prescreening.table";



export class PrescreeningPage implements IFilter {

    summaryData: PrescreeningEntry[] = [];
    //summaryMap: Map<string, PrescreeningEntry> = new Map<string, PrescreeningEntry>();
   
    //chart: PrescreeningChart;
    table: PrescreeningTable;

    constructor(DataJson: any, SiteInfoJson: any, LastUpdatedJson: any) {

        $(() => {

            new DateUpdatedSection(LastUpdatedJson);

            let siteDictionary: Map<number, string> = SiteInfo.CreateNameMap(SiteInfoJson, undefined);

            let data: PrescreeningEntry[] = plainToClass(PrescreeningEntry, <PrescreeningEntry[]>DataJson);
            //data = data.filter((el: PrescreeningEntry) => el.SiteNumber == 226);

            let weeklyData: PrescreeningEntry[] = [];

            data.forEach((element: PrescreeningEntry) => {
                element.SiteName = siteDictionary.get(element.SiteNumber);
                element.initialize();
                if (element.Type == 0) {
                    this.summaryData.push(element);
                    //this.summaryMap.set(element.getSeriesName(), element);
                }
                else if (element.Type == 1) { weeklyData.push(element); }
                else if (element.Type == 2) {
                    this.summaryData.push(element);
                    //console.log(element);    
                }
            });

            this.summaryData.forEach((summary: PrescreeningEntry) => {
                summary.WeeklyEntries = weeklyData.filter((entry: PrescreeningEntry) => summary.SiteHash == entry.SiteHash);
                summary.createChartSeries();    
            });

            InitializeFilterDropdown('#prime-contract-dropdown', Unique(this.summaryData.map((entry: PrescreeningEntry) => entry.PrimeContract), true), this);

            $('#loading-indicator').hide();
            $('.loaded-content').removeClass('invisible');

            //this.chart = new PrescreeningChart(this.summaryMap);
            //this.chart = new PrescreeningChart(new Map(this.summaryData.map((entry: PrescreeningEntry) => [entry.ChartSeriesName, entry])));
            //this.table = new PrescreeningTable(this.summaryData, GetSelectedDropdownValues('#prime-contract-dropdown'), this.chart);
            this.table = new PrescreeningTable(this.summaryData, GetSelectedDropdownValues('#prime-contract-dropdown'));

            //console.log(this.data);
            //console.log(SiteDictionaryJson);
            this.triggerFilter();
                
        });
    }

    triggerFilter(): void {

        let selectedPrimeContracts: string[] = GetSelectedDropdownValues('#prime-contract-dropdown');

        if (selectedPrimeContracts.length == 0) {
            $('#page-content').hide();
        }
        else {
            $('#page-content').show();
            this.table.updateData(selectedPrimeContracts);
        }
    }
}